import { TemplateContentType } from "features/Influencer/ContactList/schema";

export enum TemplateCreatePage {
  method = "method",
  import = "import",
  questions = "questions",
  prompt = "prompt",
  bentoAi = "bento-ai",
  edit = "edit",
}

export interface FormAnswer {
  templateContentType?: TemplateContentType;
  userPrompt?: string; // user's description of what they want
}
